import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';

@Component({
    selector: 'om-project-list-report',
    templateUrl: './projectListReport.html',
    styleUrls: ['../../reports.css', './projectListReport.css']
})

export class ProjectListReportComponent implements OnInit {
    projectIds: number[];
    reportData: IProjectListReportData;
    isGenerating = false;
    error = false;
    errorMessage = this.reportHelper.reportErrorMessages.noReportData;

    constructor(private readonly reportsApi: ReportsApi,
                private readonly reportHelper: ReportHelper,
                private readonly route: ActivatedRoute,
                titleService: Title) {
        titleService.setTitle(titleService.getTitle() + ' : Project List Report');
    }

    async ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe(x => {
            this.projectIds = JSON.parse(window.localStorage.getItem(x.get('id'))).projectIds;
            this.loadReport();
        });
    }

    private loadReport() {
        return this.reportsApi.getProjectListReportData(this.projectIds).then((reportData: IProjectListReportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
}

interface IProjectListReportData {
    projects: any[];
}
